module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile.4243e807.png";